'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

/**
 * Font Lab gate. Costs normal visitors one tiny effect and NOTHING else: the panel (and every Google Fonts request it
 * makes) is a separate chunk that only loads when someone opens any URL of the site with ?font=test.
 *   ?font=test   turn the lab on (remembered for this tab only, so it follows you from page to page until you close the tab)
 *   ?font=off    turn it off and forget the picks
 * It is deliberately NOT permanent: a lab left on in a browser keeps loading extra fonts after every page load.
 * Optional share params: &p=<primary family>&s=<secondary family>&w=<heading weight>&t=<heading tracking, em>
 */
const Panel = dynamic(() => import('./FontLabPanel'), { ssr: false });

export function FontLabGate() {
  const [on, setOn] = useState(false);
  useEffect(() => {
    try {
      const q = new URLSearchParams(window.location.search).get('font');
      localStorage.removeItem('fontlab.on'); // an older version kept the lab on forever in this browser — clear it
      if (q === 'off') { sessionStorage.removeItem('fontlab.on'); localStorage.removeItem('fontlab.cfg'); }
      else if (q === 'test' || q === 'lab') sessionStorage.setItem('fontlab.on', '1');
      setOn(sessionStorage.getItem('fontlab.on') === '1');
    } catch { /* storage blocked: lab simply stays off */ }
  }, []);
  return on ? <Panel onExit={() => setOn(false)} /> : null;
}
